import { render, staticRenderFns } from "./NovaIntegracao.vue?vue&type=template&id=9769ac2c&scoped=true&"
import script from "./NovaIntegracao.vue?vue&type=script&lang=js&"
export * from "./NovaIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./NovaIntegracao.vue?vue&type=style&index=0&id=9769ac2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9769ac2c",
  null
  
)

export default component.exports